//@ts-nocheck
export { extend } from '@zjs/common/objects';
export { findPosition } from '@zjs/common/dom';
export { buildURLWithParam } from '@zjs/common/fetch';

export function isBotAgent(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return /bot|googlebot|crawler|spider|robot|crawling/i.test(userAgent);
}

export function stripHtml(html: string) {
    return html.replace(/<[^>]*>?/gm, '');
}

export const getBoardIdFromProvince = (province: string) => {
    const boardId = province.replace(/_/g, '').toLowerCase();
    if (boardId == "hochiminh") {
        return "tphochiminh";
    }
    if (boardId == "bariavungtau") {
        return "vungtau";
    }
    return boardId;
}

const instanceOf = (input, constructor) => Boolean(input && constructor && input instanceof constructor);

export const isElement = input => instanceOf(input, Element);

